import { makeStyles, Theme } from '@material-ui/core';

/**
 * Interface pour les props du composant GridItem
 */
export interface GridItemProps<T> {
  /** Valeur de l'élément à afficher */
  value: T;
  /** Fonction appelée lors de la suppression */
  onDelete?: (value: T) => any;
  /** Fonction appelée lors de la modification */
  onChange?: (value: T) => any;
}

/**
 * Styles pour les éléments de grille avec fond gris
 * 
 * @param theme Thème Material-UI
 * @returns Styles CSS pour les éléments de grille
 */
export const useGridItemStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.grey['300'],
    margin: theme.spacing(1, 0),
    padding: theme.spacing(0.3, 0),
    borderRadius: '5px',

    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));

/**
 * Styles pour les éléments de grille sans fond
 * 
 * @param theme Thème Material-UI
 * @returns Styles CSS pour les éléments de grille clairs
 */
export const useGridItemClearStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(1, 0),
    borderRadius: '5px',

    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));
